import { takeLatest, put } from 'redux-saga/effects';
import { TRIGGER_HOVER, CLEAR_HOVER } from './constants';

function* handleHover(action) {
    const { payload } = action;
}

function* handleHoverClear() {}

export default function* animationSaga() {
    yield takeLatest(TRIGGER_HOVER, handleHover);
    yield takeLatest(CLEAR_HOVER, handleHoverClear);
}
